var _path, _path2, _g, _path3, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViettelTendooAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 36,
    viewBox: "0 0 127 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5234_47868)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 18.0039C28 10.2719 21.732 4.00391 14 4.00391C6.26801 4.00391 0 10.2719 0 18.0039C0 25.7359 6.26801 32.0039 14 32.0039C21.732 32.0039 28 25.7359 28 18.0039Z",
    fill: "url(#paint0_linear_5234_47868)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5234_47868",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 28,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18C28 10.268 21.732 4 14 4C6.26801 4 0 10.268 0 18C0 25.732 6.26801 32 14 32C21.732 32 28 25.732 28 18Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5234_47868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5551 28.3567H4.40723V34.436H24.5551V28.3567Z",
    fill: "url(#paint1_linear_5234_47868)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5234_47868",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 28,
    height: 28
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18C28 10.268 21.732 4 14 4C6.26801 4 0 10.268 0 18C0 25.732 6.26801 32 14 32C21.732 32 28 25.732 28 18Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5234_47868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.458 8.08285C14.1542 7.99138 13.8504 7.99138 13.5466 8.08215C13.5079 9.25161 13.5119 10.342 12.9668 11.1318C13.6565 11.602 14.346 11.602 15.0355 11.1318C14.4912 10.3415 14.4951 9.25161 14.458 8.08285Z",
    fill: "url(#paint2_linear_5234_47868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0006 9.02913C14.6887 9.02913 15.2464 8.47138 15.2464 7.78336C15.2464 7.09535 14.6887 6.5376 14.0006 6.5376C13.3126 6.5376 12.7549 7.09535 12.7549 7.78336C12.7549 8.47138 13.3126 9.02913 14.0006 9.02913Z",
    fill: "url(#paint3_linear_5234_47868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6239 23.3131L22.2383 17.4438L25.8197 18.0538C26.2789 18.1429 26.6284 18.4378 26.7115 18.8063L27.3028 21.4271C27.4311 21.9955 27.0526 22.5599 26.3863 22.7944L24.7594 23.367C24.703 23.3868 24.6374 23.3609 24.6239 23.3131Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.38342 23.3131L5.76902 17.4438L2.18759 18.0538C1.72839 18.1429 1.37886 18.4378 1.29579 18.8063L0.704524 21.4271C0.57619 21.9955 0.954657 22.5599 1.62106 22.7944L3.24786 23.367C3.30432 23.3868 3.36989 23.3609 3.38342 23.3131Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6446 23.8122C25.6446 23.8468 25.6446 23.8846 25.6416 23.9191C25.6269 24.6989 25.4486 25.4521 25.1289 26.1628C24.1732 28.2883 22.0641 29.583 19.8187 29.583H8.18427C5.92396 29.583 3.8039 28.2701 2.85517 26.1239C2.53597 25.4017 2.3626 24.6364 2.3584 23.8437V23.8122C2.3584 23.5227 2.38243 23.2396 2.42467 22.9594L2.6321 20.977C3.23667 15.1651 7.87463 10.7661 13.3969 10.7661H14.603C20.1253 10.7661 24.7663 15.1651 25.3679 20.977L25.5723 22.9279C25.6203 23.2175 25.6444 23.5131 25.6444 23.8122H25.6446Z",
    fill: "url(#paint4_linear_5234_47868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0017 28.4655C10.288 28.4655 6.99449 27.6579 5.39289 26.3557C4.38232 25.6681 3.87786 24.5236 4.07549 23.3606L4.79579 19.1224C5.05059 17.6234 6.39762 16.5356 7.99922 16.5356C8.42879 16.5356 8.85042 16.6159 9.25246 16.7741C10.1921 17.1442 11.2311 17.392 12.3404 17.5105C12.8197 17.5625 13.2947 17.5891 13.7537 17.5891C13.8344 17.5891 13.9133 17.5882 13.9896 17.5866C14.0937 17.5884 14.1725 17.5891 14.253 17.5891C14.7099 17.5891 15.1838 17.5625 15.6619 17.5105C16.7726 17.392 17.8111 17.1442 18.751 16.7741C19.153 16.6159 19.5744 16.5356 20.0038 16.5356C21.6051 16.5356 22.9526 17.6234 23.2077 19.1221L23.928 23.3611C24.1251 24.5238 23.6207 25.6685 22.6103 26.3559C21.0087 27.6582 17.7152 28.4657 14.0015 28.4657L14.0017 28.4655Z",
    fill: "url(#paint5_linear_5234_47868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3079 23.8206L22.5876 19.3586C22.3177 17.687 20.5576 16.7193 18.9934 17.3678C17.8678 17.8344 16.7382 18.0741 15.7349 18.1868C15.0962 18.2598 14.5085 18.2817 14.0047 18.2708C13.5012 18.2817 12.9097 18.2598 12.271 18.1868C11.2677 18.0741 10.1381 17.8342 9.01253 17.3678C7.44827 16.7193 5.68823 17.687 5.41827 19.3586L4.69797 23.8206C4.5309 24.8554 4.99523 25.8249 5.7825 26.3772C7.2 27.6083 10.3463 28.4651 14.0031 28.4651C17.6599 28.4651 20.8059 27.6083 22.2234 26.3772C23.0107 25.8249 23.475 24.8557 23.3079 23.8206Z",
    fill: "url(#paint6_linear_5234_47868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32675 25.2897C9.12044 25.2897 9.76385 24.5539 9.76385 23.6463C9.76385 22.7387 9.12044 22.0029 8.32675 22.0029C7.53306 22.0029 6.88965 22.7387 6.88965 23.6463C6.88965 24.5539 7.53306 25.2897 8.32675 25.2897Z",
    fill: "url(#paint7_linear_5234_47868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6764 25.2897C20.47 25.2897 21.1135 24.5539 21.1135 23.6463C21.1135 22.7387 20.47 22.0029 19.6764 22.0029C18.8827 22.0029 18.2393 22.7387 18.2393 23.6463C18.2393 24.5539 18.8827 25.2897 19.6764 25.2897Z",
    fill: "url(#paint8_linear_5234_47868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.412 24.6482C15.6216 24.6482 15.7672 24.8608 15.6892 25.0554C15.5968 25.2864 15.4547 25.4945 15.2727 25.6718C14.9514 26.0006 14.5032 26.2022 14.0025 26.2022C13.5017 26.2022 13.0463 26.0004 12.725 25.6718C12.5481 25.4947 12.4048 25.2873 12.311 25.057C12.2317 24.8622 12.3773 24.6482 12.5878 24.6482H15.4123H15.412Z",
    fill: "url(#paint9_linear_5234_47868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2743 25.669C14.953 25.9977 14.5048 26.1993 14.0041 26.1993C13.5033 26.1993 13.0479 25.9975 12.7266 25.669C13.018 25.3925 13.4812 25.2133 13.9968 25.2133C14.5125 25.2133 14.9754 25.3925 15.2743 25.669Z",
    fill: "url(#paint10_linear_5234_47868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1201 20.635H11.0585C10.5424 20.635 10.124 21.0534 10.124 21.5695V23.0444C10.124 23.5605 10.5424 23.9789 11.0585 23.9789H11.1201C11.6362 23.9789 12.0546 23.5605 12.0546 23.0444V21.5695C12.0546 21.0534 11.6362 20.635 11.1201 20.635Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9424 20.635H16.8808C16.3647 20.635 15.9463 21.0534 15.9463 21.5695V23.0444C15.9463 23.5605 16.3647 23.9789 16.8808 23.9789H16.9424C17.4585 23.9789 17.8769 23.5605 17.8769 23.0444V21.5695C17.8769 21.0534 17.4585 20.635 16.9424 20.635Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6196 26.6899H15.8879C15.3371 26.6899 14.8906 27.1364 14.8906 27.6871C14.8906 28.2378 15.3371 28.6842 15.8879 28.6842H16.6196C17.1704 28.6842 17.6169 28.2378 17.6169 27.6871C17.6169 27.1364 17.1704 26.6899 16.6196 26.6899Z",
    fill: "#21201E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8203 27.8072C16.8203 27.8072 24.7658 28.8138 26.1385 21.7954",
    stroke: "#21201E",
    strokeWidth: 0.6293,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5234_47868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.4 29.502H124V16.502H126.4V29.502Z",
    fill: "#EE0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1241 13.5188H45.8324C45.8994 13.5189 45.9658 13.5058 46.0278 13.4803C46.0897 13.4547 46.146 13.4171 46.1935 13.3698C46.2409 13.3224 46.2785 13.2662 46.3042 13.2043C46.3299 13.1424 46.3431 13.076 46.3431 13.009V7.7645C46.3429 7.62921 46.289 7.49952 46.1932 7.40392C46.0975 7.30833 45.9677 7.25464 45.8324 7.25464H45.1241C44.989 7.25485 44.8594 7.30863 44.7638 7.40421C44.6683 7.49978 44.6145 7.62934 44.6143 7.7645V13.009C44.6143 13.1442 44.668 13.2739 44.7636 13.3695C44.8592 13.4651 44.9889 13.5188 45.1241 13.5188Z",
    fill: "#EE0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1961 13.5897C40.6247 13.5897 41.1274 13.5666 41.3911 13.032L44.3762 7.2522H43.2847C43.0729 7.25372 42.8659 7.31581 42.6882 7.43114C42.5105 7.54646 42.3694 7.71022 42.2817 7.90308L40.4008 11.9016C40.3562 11.9956 40.2678 12.1493 40.1937 12.1493C40.1196 12.1493 40.0343 11.9956 39.9873 11.9016L38.0968 7.90547C38.0087 7.71297 37.8675 7.54953 37.6899 7.43427C37.5123 7.31901 37.3055 7.25669 37.0938 7.25459H36L38.9851 13.0344C39.2807 13.6017 39.8862 13.5921 40.1961 13.5921",
    fill: "#EE0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9828 13.5189C78.118 13.5189 78.2477 13.4652 78.3433 13.3695C78.4389 13.2739 78.4927 13.1442 78.4927 13.009V12.4513H78.064C77.7541 12.4513 77.108 12.4394 76.7201 12.1797C76.2174 11.8483 76.262 11.2571 76.262 10.8317V6.29069C76.262 6.15526 76.2082 6.02537 76.1124 5.9296C76.0166 5.83383 75.8867 5.78003 75.7513 5.78003H75.0439C74.9084 5.78003 74.7785 5.83383 74.6828 5.9296C74.587 6.02537 74.5332 6.15526 74.5332 6.29069V11.469C74.5332 12.2609 74.8144 12.7214 75.3163 13.0528C75.8039 13.3715 76.3655 13.5133 77.414 13.5133L77.9828 13.5189Z",
    fill: "#EE0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3339 11.4747C56.3339 12.2666 56.6144 12.727 57.117 13.0584C57.6046 13.3771 58.1663 13.5189 59.2147 13.5189H59.7835C59.9187 13.5189 60.0484 13.4652 60.144 13.3696C60.2397 13.274 60.2934 13.1443 60.2934 13.0091V12.4514H59.8648C59.5541 12.4514 58.9088 12.4394 58.52 12.1797C58.0181 11.8483 58.0619 11.2572 58.0619 10.8318V8.31667H61.6676V11.4731C61.6676 12.265 61.9481 12.7254 62.4508 13.0569C62.9375 13.3755 63.4992 13.5173 64.5484 13.5173H65.1164C65.1834 13.5174 65.2498 13.5043 65.3117 13.4787C65.3736 13.4531 65.4298 13.4156 65.4772 13.3682C65.5245 13.3209 65.5621 13.2646 65.5877 13.2027C65.6133 13.1408 65.6264 13.0744 65.6263 13.0075V12.4498H65.1985C64.8886 12.4498 64.2385 12.4378 63.8537 12.1781C63.3518 11.8467 63.3964 11.2556 63.3964 10.8302V8.31667H65.0694C65.2046 8.31667 65.3343 8.26295 65.4299 8.16733C65.5256 8.07171 65.5793 7.94202 65.5793 7.8068V7.24913H63.3932V6.29472C63.3932 6.15942 63.3395 6.02966 63.2439 5.93391C63.1483 5.83816 63.0186 5.78427 62.8834 5.78406H62.1751C62.1081 5.78406 62.0417 5.79727 61.9798 5.82295C61.9179 5.84862 61.8616 5.88625 61.8143 5.93368C61.7669 5.98111 61.7294 6.03741 61.7038 6.09936C61.6782 6.16131 61.6651 6.2277 61.6652 6.29472V7.25471H58.0587V6.29472C58.0588 6.2277 58.0457 6.16131 58.0201 6.09936C57.9946 6.03741 57.957 5.98111 57.9097 5.93368C57.8623 5.88625 57.8061 5.84862 57.7441 5.82295C57.6822 5.79727 57.6159 5.78406 57.5488 5.78406H56.8406C56.7053 5.78427 56.5756 5.83816 56.48 5.93391C56.3844 6.02966 56.3307 6.15942 56.3307 6.29472V7.25471H55.252V7.81238C55.252 7.9476 55.3058 8.07729 55.4014 8.17291C55.497 8.26853 55.6267 8.32224 55.7619 8.32224H56.3339V11.4747Z",
    fill: "#EE0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5019 10.611C54.8262 10.3513 54.8708 9.98484 54.8708 9.66617C54.8708 8.87428 54.6788 8.09355 53.7634 7.63307C53.0392 7.2666 52.0904 7.23474 51.1774 7.23474C50.4389 7.23474 49.1061 7.23474 48.2521 7.82587C47.398 8.417 47.3184 9.27262 47.3184 10.4461C47.3184 11.2731 47.363 12.1359 47.876 12.727C48.5261 13.4599 49.4694 13.5189 50.266 13.5189H54.1036C54.1706 13.519 54.2369 13.5059 54.2988 13.4803C54.3608 13.4547 54.417 13.4171 54.4644 13.3698C54.5117 13.3224 54.5493 13.2662 54.5749 13.2042C54.6005 13.1423 54.6136 13.076 54.6135 13.009V12.4513H50.7895C50.1521 12.4513 49.4303 12.3804 49.2089 11.7065C49.14 11.424 49.1052 11.1344 49.1053 10.8437H53.6559C53.9658 10.8437 54.2613 10.7967 54.498 10.6047L54.5019 10.611ZM52.6959 9.78408H50.2374C49.6128 9.78408 49.1061 10.0701 49.1061 10.4214V9.78408C49.1204 9.37061 49.1061 9.02725 49.4606 8.70858C49.933 8.28316 50.6429 8.29511 51.1002 8.29511C51.5877 8.29511 52.1494 8.31901 52.578 8.57872C52.7261 8.6643 52.8499 8.78626 52.9378 8.93306C53.0256 9.07986 53.0745 9.24663 53.0799 9.41761C53.0799 9.58332 53.0361 9.78408 52.6959 9.78408Z",
    fill: "#EE0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9626 13.5189H72.7962C72.8632 13.519 72.9295 13.5059 72.9914 13.4803C73.0533 13.4547 73.1096 13.4172 73.1569 13.3698C73.2043 13.3224 73.2419 13.2662 73.2675 13.2043C73.293 13.1424 73.3062 13.076 73.3061 13.009V12.4514H69.4788C68.8415 12.4514 68.1197 12.3805 67.8983 11.7065C67.8297 11.424 67.795 11.1344 67.7947 10.8437H72.3469C72.6568 10.8437 72.9523 10.7967 73.1889 10.6047C73.514 10.345 73.5586 9.97849 73.5586 9.65983C73.5586 8.86794 73.3666 8.0872 72.4504 7.62673C71.7263 7.26026 70.7774 7.22839 69.8644 7.22839C69.1259 7.22839 67.7931 7.22839 66.9391 7.81952C66.085 8.41065 66.0078 9.27265 66.0078 10.4461C66.0078 11.2731 66.0524 12.1359 66.5694 12.727C67.2195 13.4599 68.1627 13.5189 68.9594 13.5189H68.9626ZM67.7955 9.78411C67.8106 9.37064 67.7955 9.02727 68.15 8.7086C68.6232 8.28318 69.3323 8.29513 69.7903 8.29513C70.2779 8.29513 70.8388 8.31903 71.2674 8.57875C71.4156 8.66423 71.5396 8.78615 71.6276 8.93295C71.7156 9.07975 71.7646 9.24658 71.7701 9.41764C71.7701 9.58335 71.7255 9.78411 71.3853 9.78411H68.9268C68.3022 9.78411 67.7955 10.0701 67.7955 10.4214V9.78411Z",
    fill: "#EE0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4786 6.6635H45.8324C45.9678 6.6635 46.0977 6.60969 46.1935 6.51392C46.2893 6.41816 46.3431 6.28827 46.3431 6.15283V6.01182C46.3431 5.9448 46.3299 5.87843 46.3042 5.81652C46.2785 5.75461 46.2409 5.69837 46.1935 5.65101C46.146 5.60365 46.0897 5.56611 46.0278 5.54054C45.9658 5.51496 45.8994 5.50185 45.8324 5.50195H45.1249C45.0579 5.50185 44.9915 5.51496 44.9296 5.54054C44.8676 5.56611 44.8113 5.60365 44.7639 5.65101C44.7164 5.69837 44.6788 5.75461 44.6531 5.81652C44.6275 5.87843 44.6143 5.9448 44.6143 6.01182V7.25462H44.623C44.6716 6.96543 45.0006 6.6635 45.4802 6.6635",
    fill: "#EE0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.315 22.164C106.679 22.164 106.638 22.1408 106.531 21.5206C106.146 19.2523 104.373 18.0187 102.408 17.6307C102.264 17.6041 102.114 17.6074 101.976 17.5677C101.805 17.5179 101.52 17.4582 101.507 17.3687C101.463 17.0967 101.507 16.8049 101.567 16.5297C101.581 16.4667 101.802 16.407 101.923 16.4169C104.577 16.6457 106.609 17.7932 107.671 20.3102C107.818 20.6617 107.885 21.053 107.956 21.4344C108.073 22.0811 107.989 22.164 107.319 22.164H107.315Z",
    fill: "#EE0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.791 22.1605C104.198 22.1671 104.218 22.1605 104.07 21.6C103.826 20.6682 103.172 20.121 102.267 19.8391C102.183 19.8126 102.093 19.7993 102.006 19.7827C101.483 19.6733 101.402 19.5705 101.463 19.0664C101.499 18.758 101.653 18.5889 101.989 18.5823C103.269 18.5524 104.208 19.1825 104.905 20.1542C105.217 20.5886 105.361 21.1524 105.535 21.673C105.636 21.9681 105.461 22.1439 105.126 22.1671C105.015 22.1738 104.901 22.1671 104.788 22.1671L104.791 22.1605Z",
    fill: "#EE0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1335 20.4129C76.1335 20.2405 76.1335 20.0846 76.1335 19.9288C76.1335 19.0864 76.1401 18.2408 76.1335 17.3985C76.1335 17.1166 76.2206 16.9806 76.5325 16.9906C77.0755 17.0072 77.6151 17.0005 78.1578 16.9939C78.4193 16.9906 78.5134 17.1 78.5134 17.3554C78.5099 20.9966 78.5099 24.6379 78.5134 28.2758C78.5134 28.5411 78.3894 28.6704 78.1446 28.7135C77.1627 28.8893 76.1873 29.1347 75.1984 29.2309C73.7838 29.3668 72.3594 29.4166 70.9514 29.1015C69.4332 28.76 68.1997 28.0237 67.7606 26.4618C67.04 23.9016 68.0355 21.3813 71.0153 20.5357C72.1313 20.2206 73.2744 20.1377 74.4307 20.2637C74.9671 20.3201 75.5033 20.3533 76.1335 20.4063V20.4129ZM76.1134 22.2833C75.0276 22.2369 73.9782 22.154 72.9293 22.1673C72.4129 22.1739 71.8768 22.2899 71.3907 22.4657C70.3013 22.867 69.8622 23.9149 70.0198 25.3442C70.1538 26.5447 70.6198 27.0886 71.7928 27.2444C72.7515 27.3705 73.7369 27.3273 74.7088 27.3141C75.1748 27.3074 75.6408 27.1914 76.1134 27.125V22.2833Z",
    fill: "#EE0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5993 20.456C90.1007 20.9866 90.8952 21.7991 90.959 23.3677C91.0024 24.482 90.9858 25.6095 90.875 26.7205C90.7778 27.6921 90.151 28.4117 89.2427 28.7599C88.5222 29.0352 87.7413 29.2342 86.9735 29.2938C85.4919 29.4099 83.9936 29.4597 82.5325 29.0949C81.1817 28.7599 80.1893 28.0237 79.9682 26.5845C79.7737 25.311 79.7737 24.0277 79.9918 22.7542C80.1692 21.7195 80.796 20.9899 81.7682 20.6351C82.4554 20.3831 83.8898 19.9752 85.1235 19.9752C86.6148 19.9752 87.6572 20.1244 88.6024 20.456H88.5993ZM87.3256 27.586C88.1031 27.4135 88.4382 26.9725 88.4552 26.1832C88.4753 25.2215 88.4753 24.2631 88.4552 23.3014C88.4382 22.4922 88.1399 22.0943 87.3423 21.8886C86.8628 21.7659 86.3568 21.6864 85.8641 21.6996C85.0596 21.7195 84.2419 21.756 83.4575 21.9152C82.7269 22.0644 82.4217 22.5552 82.4116 23.2981C82.4016 24.2332 82.4016 25.1684 82.4116 26.1003C82.4217 26.9559 82.7536 27.4102 83.588 27.5893C84.1915 27.7186 86.7086 27.7186 87.3256 27.5827V27.586Z",
    fill: "#EE0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.06 20.456C102.562 20.9866 103.356 21.7991 103.42 23.3677C103.463 24.482 103.446 25.6095 103.336 26.7205C103.239 27.6921 102.612 28.4117 101.704 28.7599C100.983 29.0352 100.202 29.2342 99.4341 29.2938C97.9529 29.4099 96.4546 29.4597 94.9931 29.0949C93.6423 28.7599 92.6503 28.0237 92.4291 26.5845C92.2347 25.311 92.2347 24.0277 92.4524 22.7542C92.6302 21.7195 93.2569 20.9899 94.2288 20.6351C94.916 20.3831 96.3507 19.9752 97.5841 19.9752C99.0758 19.9752 100.118 20.1244 101.063 20.456H101.06ZM99.7897 27.586C100.567 27.4135 100.902 26.9725 100.919 26.1832C100.939 25.2215 100.939 24.2631 100.919 23.3014C100.902 22.4922 100.604 22.0943 99.8064 21.8886C99.3272 21.7659 98.8209 21.6864 98.3282 21.6996C97.5237 21.7195 96.706 21.756 95.9216 21.9152C95.191 22.0644 94.8858 22.5552 94.8757 23.2981C94.8656 24.2332 94.8656 25.1684 94.8757 26.1003C94.8858 26.9559 95.2177 27.4102 96.0521 27.5893C96.6556 27.7186 99.1727 27.7186 99.7897 27.5827V27.586Z",
    fill: "#EE0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4184 22.1904V22.6713C58.4184 24.6644 58.4083 26.6574 58.4251 28.6505C58.4251 29.0286 58.2944 29.1479 57.9324 29.1313C57.4329 29.1114 56.9302 29.1181 56.4274 29.1247C56.1727 29.128 56.0654 29.0385 56.0654 28.7732C56.0721 26.3788 56.0688 23.9845 56.0755 21.5902C56.0755 21.0629 56.3436 20.6848 56.8598 20.5489C57.3022 20.4328 57.7614 20.3599 58.2139 20.33C59.9837 20.214 61.7568 20.0879 63.5065 20.5058C65.5813 20.9999 66.5063 22.0512 66.6036 24.1537C66.674 25.6891 66.6203 27.2311 66.6304 28.7666C66.6304 29.0286 66.5097 29.1214 66.2617 29.1214C65.7321 29.1214 65.2059 29.1081 64.6763 29.128C64.3444 29.1413 64.2606 28.9921 64.264 28.6936C64.274 27.4898 64.274 26.286 64.264 25.0822C64.264 24.734 64.2472 24.3825 64.1903 24.0442C64.0428 23.1919 63.5501 22.6182 62.7054 22.3596C61.301 21.9251 59.8764 22.0677 58.4151 22.1904H58.4184Z",
    fill: "#EE0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5333 27.6589C43.5333 28.017 43.54 28.3785 43.5031 28.7333C43.4729 28.9986 43.2517 29.1213 43.0037 29.1246C42.0316 29.1313 41.0596 29.1777 40.101 28.9655C38.5223 28.614 37.7513 27.6688 37.748 26.0704C37.7413 24.7671 37.7379 23.4638 37.7547 22.1605C37.7547 21.9582 37.5905 21.7957 37.3826 21.7991C36.7894 21.8156 36.7894 21.809 36.424 21.8057C36.2363 21.8057 36.0821 21.6531 36.0821 21.4641V20.897C36.0754 20.4891 36.4106 20.1542 36.8262 20.1575C36.9603 20.1575 37.1178 20.1575 37.4463 20.1608C37.6642 20.1608 37.7681 20.1077 37.748 19.8723C37.7279 19.6302 37.7446 19.3848 37.7446 19.1394C37.748 19.0266 37.7413 18.9106 37.7614 18.7978C37.8519 18.2241 38.2575 18.055 39.444 18.0915C39.9736 18.108 40.3088 18.3966 40.349 18.8874C40.3591 19.03 40.3557 19.1726 40.3557 19.3152C40.3591 20.3929 40.3557 20.0912 42.1925 20.1774C42.4741 20.1906 42.7556 20.1906 43.0372 20.1608C43.4126 20.1177 43.5064 20.2271 43.4763 20.5024C43.4629 20.6317 43.4763 20.761 43.4696 20.8904C43.4494 21.5006 43.1746 21.7858 42.5579 21.7991C41.9512 21.8123 41.3412 21.8123 40.7311 21.7991C40.4697 21.7924 40.3457 21.8322 40.349 22.1406C40.3691 23.3311 40.3457 24.5217 40.3591 25.7089C40.3725 26.7834 40.8317 27.2675 41.9076 27.4201C42.3534 27.4864 42.8026 27.4698 43.2517 27.4831C43.3824 27.4831 43.5366 27.4632 43.5333 27.6555V27.6589Z",
    fill: "#EE0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.117 25.3608C49.0712 25.3608 48.0288 25.3708 46.983 25.3542C46.6881 25.3509 46.6177 25.4371 46.6479 25.719C46.7886 27.019 47.2981 27.4733 48.7193 27.4799C50.4891 27.4899 52.2588 27.4932 54.0286 27.4799C54.3738 27.4799 54.5012 27.5429 54.4945 27.9177C54.4744 29.1281 54.4911 29.1314 53.251 29.1314C51.5382 29.1314 49.8287 29.1347 48.1159 29.1281C47.7238 29.1281 47.3316 29.1016 46.9462 29.0552C45.2769 28.8529 44.2647 27.8779 44.0367 26.2363C43.8893 25.1818 43.8993 24.1172 44.0434 23.0627C44.2178 21.7859 44.9719 20.9668 46.1819 20.539C46.8422 20.3035 47.5294 20.2008 48.2266 20.1643C49.4433 20.1012 50.6633 20.088 51.8734 20.2803C52.3191 20.35 52.7482 20.4793 53.1605 20.665C54.6319 21.3349 55.0744 22.7908 54.7425 24.3361C54.6051 24.9861 54.0286 25.3443 53.2543 25.3542C52.2119 25.3708 51.1661 25.3575 50.1203 25.3575V25.3642L50.117 25.3608ZM46.6412 24.4522C47.1842 23.9083 47.7975 23.7956 48.4478 23.7923C49.5204 23.7889 50.5963 23.7923 51.6689 23.7889C52.2387 23.7856 52.4063 23.5701 52.2554 23.0328C52.0912 22.4326 51.6454 22.091 51.0689 21.9451C50.0566 21.6898 49.0243 21.6798 48.0087 21.9086C47.0836 22.1175 46.678 22.6515 46.6412 23.5933C46.6311 23.8486 46.6412 24.104 46.6412 24.4522Z",
    fill: "#EE0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 29.4969C109.227 28.8693 109.443 28.2733 109.659 27.678C110.813 24.5077 111.974 21.34 113.118 18.1666C113.474 17.1807 114.111 16.6432 115.077 16.534C115.538 16.476 116.004 16.4968 116.459 16.5956C117.246 16.7745 117.747 17.3027 118.028 18.1073C118.798 20.3163 119.57 22.5252 120.345 24.7341C120.87 26.2331 121.394 27.7319 121.919 29.2306C121.945 29.3086 121.969 29.3866 122 29.4852C121.93 29.4906 121.876 29.4981 121.822 29.4981C121.185 29.4981 120.548 29.4949 119.911 29.502C119.777 29.502 119.71 29.4665 119.659 29.3207C118.701 26.5481 117.738 23.7769 116.772 21.0071C116.575 20.44 116.381 19.8716 116.183 19.3048C116.057 18.9435 115.889 18.8012 115.597 18.7981C115.281 18.7961 115.095 18.94 114.963 19.3017C114.276 21.1954 113.589 23.0894 112.903 24.9836C112.377 26.4368 111.848 27.8893 111.318 29.341C111.294 29.4065 111.21 29.4903 111.156 29.491C110.448 29.5004 109.74 29.4969 109 29.4969Z",
    fill: "#EE0033"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5234_47868",
    x1: 14,
    y1: 28.4988,
    x2: 14,
    y2: -1.16396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FBEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F7D6D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#F2B8BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5234_47868",
    x1: 14.529,
    y1: 25.5042,
    x2: 14.4828,
    y2: 31.1931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#D9373C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#DA4045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E26468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E78184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#EB9598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#EEA1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFA6A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E89598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#DD757A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D45A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CC444B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C6333A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2272F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#BF2028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BF1F27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5234_47868",
    x1: 14.0234,
    y1: 8.04373,
    x2: 13.9268,
    y2: 11.2228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AFB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576923,
    stopColor: "#FFD2D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913729,
    stopColor: "#F28C93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5234_47868",
    x1: 14.0275,
    y1: 6.55883,
    x2: 13.9605,
    y2: 9.62063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAEB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416941,
    stopColor: "#FFD2D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913729,
    stopColor: "#F28C93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5234_47868",
    x1: 14.0015,
    y1: 11.1509,
    x2: 14.0015,
    y2: 27.5547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#D9373C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFA6A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ED9C9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E5787C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E05B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DC474C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#D93B40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#D9373C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#CF2E34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#C3222A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BF1F27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5234_47868",
    x1: 13.8643,
    y1: 16.4262,
    x2: 14.0874,
    y2: 28.4683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FBEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F7D5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F4C5C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F2BBBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B8BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5234_47868",
    x1: 13.8701,
    y1: 17.0553,
    x2: 14.0812,
    y2: 28.4677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FCF1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FEFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FEFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FBEEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F8DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F3BDBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B8BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5234_47868",
    x1: 8.32675,
    y1: 21.8422,
    x2: 8.32675,
    y2: 25.8459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FAB5B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5A398"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5234_47868",
    x1: 19.6764,
    y1: 21.8422,
    x2: 19.6764,
    y2: 25.8459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FAB5B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5A398"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5234_47868",
    x1: 12.2889,
    y1: 25.4252,
    x2: 15.7105,
    y2: 25.4252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D5544C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DB5C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E96D64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F2776D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F57B71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5234_47868",
    x1: 14.0125,
    y1: 25.1885,
    x2: 13.9943,
    y2: 25.9175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F99C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F79390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F57B71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5234_47868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28.0039,
    fill: "white",
    transform: "translate(0 4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5234_47868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 25,
    fill: "white",
    transform: "translate(36 5.50195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViettelTendooAi);
export default __webpack_public_path__ + "static/media/viettel-tendoo-ai.0d0227de9bcba5577d9a2aaf4c7eec45.svg";
export { ForwardRef as ReactComponent };